export default () => {
	$( '.js-floating-link' ).click( function ( e ) {
		e.preventDefault();
		$( this ).parent().toggleClass( 'is-active' );
	} );

	$( '.floating-link' ).click( function ( e ) {
		e.stopPropagation();
	} );

	$( 'html, body' ).click( function ( ) {
		$( '.floating-link' ).removeClass( 'is-active' );
	} );
};
